// DS: i2.20
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Carousel: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-5 16h4v-4h-4v4Zm-2 0v-4h-4v4h4Zm-6 0v-4H4v4h4Zm12-6V5H4v8h16Z"
      />
    </svg>
  </IconWrap>
);
Carousel.displayName = 'Carousel';

export default Carousel;
